// 2022 Topps Finest Star Wars — authored by hand (2026-08-22)
// =============================================================================
// CARDS: transcribed from the official Topps checklist PDF
// (CheckList_22SWFN_VERSION1.pdf, 9 pages, 375 entries). That PDF embeds two
// subset-encoded Tahoma fonts, so roughly a third of the names only decode
// correctly once the /ToUnicode CMaps are applied — the plain text layer reads
// as mojibake. All names below are the CMap-decoded values.
//
// Per-sub-set counts were cross-checked against TCDB (sid 302998) and
// breakninja's 2,114-row parallel table. All three agree everywhere except the
// Finest Autographs count: the PDF and TCDB both list 70 cards, breakninja 69.
// The difference is FA-KG, which the Topps PDF prints with a card number and NO
// NAME. TCDB identifies it as Kathleen Gati (Old Daka) and that name is used
// here; it is the one card name on this file not taken from the Topps PDF.
//
// PARALLELS: from TCDB cross-checked against breakninja, which agree on the
// base ladder, all four themed inserts, Finest Autographs and Prime Autographs.
// Two judgement calls:
//   * Galaxy's Finest Heroes Die-Cut — TCDB catalogues Orange /25, Black /10,
//     Red /5 and a Superfractor 1/1 as four separate 20-card sets; breakninja
//     lists no parallels for it at all. TCDB's are included here. Unlike a
//     phantom autograph set, a parallel legitimately shares its base card list,
//     so the shared names are not evidence against it — but this ladder rests
//     on a single source.
//   * Extended Base — breakninja only (Gold /50, Red /5, Superfractor 1/1);
//     TCDB has no Extended Base entry. The ladder matches 2018 and 2023 Finest.
//
// Rule 7: every sub-set's base card is unnumbered here — including Prime
// Autographs, which are unnumbered in 2022 (they are /10 in 2023) — so no
// sub-set takes a blank-name serial slot. Sketches are 1/1 by design. Galaxy's
// Finest Heroes Die-Cut Autographs carry an explicit empty parallel array:
// neither source lists any parallel, and an empty array is honored rather than
// falling back to a default ladder.
//
// NAMING: Topps' PDF calls the autograph sub-sets "<INSERT> AUTOGRAPH
// VARIATION" and writes the die-cut insert as "GALAXYS FINEST HEROES DIECUT"
// with no apostrophe or hyphen (verified in the raw content stream — it is
// Topps' own styling, not an extraction artefact). The collector-facing names
// used by TCDB and breakninja are used for the titles here. Unlike 2023, the
// 2022 checklist lists autograph signers with no character names, so the cards
// carry the signer alone.
// =============================================================================

export const SETS = [
  {
    id: "base",
    type: "base",
    title: "BASE",
    parallels: [
        { id: "refractor", name: "Refractor", print_run: null, color: "#c8d8f0" },
        { id: "blue-refractor", name: "Blue Refractor", print_run: 150, color: "#2979ff" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "1", name: "Adi Gallia" },
        { n: "2", name: "Admiral Ackbar" },
        { n: "3", name: "Ahsoka Tano" },
        { n: "4", name: "Allegiant General Pryde" },
        { n: "5", name: "Anakin Skywalker" },
        { n: "6", name: "Asajj Ventress" },
        { n: "7", name: "Axe Woves" },
        { n: "8", name: "Babu Frik" },
        { n: "9", name: "Bail Organa" },
        { n: "10", name: "Barriss Offee" },
        { n: "11", name: "Baze Malbus" },
        { n: "12", name: "BB-8" },
        { n: "13", name: "Beaumont Kin" },
        { n: "14", name: "Bo-Katan Kryze" },
        { n: "15", name: "Burg" },
        { n: "16", name: "C-3PO" },
        { n: "17", name: "Cad Bane" },
        { n: "18", name: "Captain Phasma" },
        { n: "19", name: "Carson Teva" },
        { n: "20", name: "Cassian Andor" },
        { n: "21", name: "Chewbacca" },
        { n: "22", name: "Chirrut Îmwe" },
        { n: "23", name: "Chopper" },
        { n: "24", name: "Cid" },
        { n: "25", name: "Cobb Vanth" },
        { n: "26", name: "Count Dooku" },
        { n: "27", name: "Crosshair" },
        { n: "28", name: "Dark Side Rey" },
        { n: "29", name: "Darth Maul" },
        { n: "30", name: "Darth Vader" },
        { n: "31", name: "Dryden Vos" },
        { n: "32", name: "Echo" },
        { n: "33", name: "Even Piell" },
        { n: "34", name: "Ezra Bridger" },
        { n: "35", name: "Fennec Shand" },
        { n: "36", name: "Finn" },
        { n: "37", name: "First Order Stormtrooper" },
        { n: "38", name: "Frog Lady" },
        { n: "39", name: "Galen Erso" },
        { n: "40", name: "General Grievous" },
        { n: "41", name: "General Hux" },
        { n: "42", name: "Gor Koresh" },
        { n: "43", name: "Grand Inquisitor" },
        { n: "44", name: "Grand Moff Tarkin" },
        { n: "45", name: "Greef Karga" },
        { n: "46", name: "Grogu" },
        { n: "47", name: "Han Solo" },
        { n: "48", name: "Hera Syndulla" },
        { n: "49", name: "Hunter" },
        { n: "50", name: "Imperial Stormtrooper" },
        { n: "51", name: "Jannah" },
        { n: "52", name: "Jar Jar Binks" },
        { n: "53", name: "Jyn Erso" },
        { n: "54", name: "K-2SO" },
        { n: "55", name: "Kanan Jarrus" },
        { n: "56", name: "Kaydel Ko Connix" },
        { n: "57", name: "Koska Reeves" },
        { n: "58", name: "Kylo Ren" },
        { n: "59", name: "Lando Calrissian" },
        { n: "60", name: "Leia Organa" },
        { n: "61", name: "Lyra Erso" },
        { n: "62", name: "Mace Windu" },
        { n: "63", name: "Maz Kanata" },
        { n: "64", name: "Migs Mayfeld" },
        { n: "65", name: "Moff Gideon" },
        { n: "66", name: "Mon Mothma" },
        { n: "67", name: "Obi-Wan Kenobi" },
        { n: "68", name: "Ochi of Bestoon" },
        { n: "69", name: "Omega" },
        { n: "70", name: "Padmé Amidala" },
        { n: "71", name: "Palpatine" },
        { n: "72", name: "Peli Motto" },
        { n: "73", name: "Poe Dameron" },
        { n: "74", name: "Qi'ra" },
        { n: "75", name: "Director Krennic" },
        { n: "76", name: "Qui-Gon Jinn" },
        { n: "77", name: "Quinlan Vos" },
        { n: "78", name: "R2-D2" },
        { n: "79", name: "Rex" },
        { n: "80", name: "Rey" },
        { n: "81", name: "Rose Tico" },
        { n: "82", name: "Sabine Wren" },
        { n: "83", name: "Saw Gerrera" },
        { n: "84", name: "Sith Trooper" },
        { n: "85", name: "Supreme Leader Snoke" },
        { n: "86", name: "Tech" },
        { n: "87", name: "The Armorer" },
        { n: "88", name: "The Client" },
        { n: "89", name: "The Mandalorian" },
        { n: "90", name: "Todo 360" },
        { n: "91", name: "Trudgen" },
        { n: "92", name: "Valin Hess" },
        { n: "93", name: "Vice Admiral Holdo" },
        { n: "94", name: "Watto" },
        { n: "95", name: "Wrecker" },
        { n: "96", name: "Xi'an" },
        { n: "97", name: "Yoda" },
        { n: "98", name: "Zeb Orrelios" },
        { n: "99", name: "Zero" },
        { n: "100", name: "Zorii Bliss" },
    ],
  },
  {
    id: "extended-base",
    type: "insert",
    title: "EXTENDED BASE",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "101", name: "Ahsoka Tano" },
        { n: "102", name: "Anakin Skywalker" },
        { n: "103", name: "BB-8" },
        { n: "104", name: "C-3PO" },
        { n: "105", name: "Captain Phasma" },
        { n: "106", name: "Chewbacca" },
        { n: "107", name: "Count Dooku" },
        { n: "108", name: "Maul" },
        { n: "109", name: "Darth Vader" },
        { n: "110", name: "Fennec Shand" },
        { n: "111", name: "Grogu" },
        { n: "112", name: "Han Solo" },
        { n: "113", name: "Kylo Ren" },
        { n: "114", name: "General Leia Organa" },
        { n: "115", name: "Obi-Wan Kenobi" },
        { n: "116", name: "R2-D2" },
        { n: "117", name: "Rey" },
        { n: "118", name: "The Mandalorian" },
        { n: "119", name: "Finn" },
        { n: "120", name: "Yoda" },
    ],
  },
  {
    id: "high-republic-concept-art",
    type: "insert",
    title: "THE HIGH REPUBLIC CONCEPT ART",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "HR-1", name: "Avar Kriss" },
        { n: "HR-2", name: "Loden Greatstorm" },
        { n: "HR-3", name: "Sskeer" },
        { n: "HR-4", name: "Keeve Trennis" },
        { n: "HR-5", name: "Ram Jamoram" },
        { n: "HR-6", name: "Vernestra Rwoh" },
        { n: "HR-7", name: "Yoda" },
        { n: "HR-8", name: "Orla Jareni" },
        { n: "HR-9", name: "Bell Zettifar" },
        { n: "HR-10", name: "Burryaga" },
        { n: "HR-11", name: "Reath Silas" },
        { n: "HR-12", name: "Lula Talisola" },
        { n: "HR-13", name: "Chancellor Lina Soh" },
        { n: "HR-14", name: "Affie Hollow" },
        { n: "HR-15", name: "Leox Gyasi" },
        { n: "HR-16", name: "Geode" },
        { n: "HR-17", name: "The Nihil" },
        { n: "HR-18", name: "Lourna Dee" },
        { n: "HR-19", name: "Marchion Ro" },
        { n: "HR-20", name: "Drengir" },
    ],
  },
  {
    id: "the-mandalorian",
    type: "insert",
    title: "THE MANDALORIAN",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MD-1", name: "Grogu" },
        { n: "MD-2", name: "The Mandalorian" },
        { n: "MD-3", name: "Koska Reeves" },
        { n: "MD-4", name: "Kuiil" },
        { n: "MD-5", name: "IG-11" },
        { n: "MD-6", name: "Boba Fett" },
        { n: "MD-7", name: "Fennec Shand" },
        { n: "MD-8", name: "Greef Karga" },
        { n: "MD-9", name: "Ahsoka Tano" },
        { n: "MD-10", name: "Moff Gideon" },
        { n: "MD-11", name: "The Armorer" },
        { n: "MD-12", name: "Mayfeld" },
        { n: "MD-13", name: "Cobb Vanth" },
        { n: "MD-14", name: "Peli Motto" },
        { n: "MD-15", name: "Bo-Katan Kryze" },
        { n: "MD-16", name: "Frog Lady" },
        { n: "MD-17", name: "The Client" },
        { n: "MD-18", name: "Axe Woves" },
        { n: "MD-19", name: "Valin Hess" },
        { n: "MD-20", name: "Luke Skywalker" },
    ],
  },
  {
    id: "the-bad-batch",
    type: "insert",
    title: "THE BAD BATCH",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "BB-1", name: "Hunter" },
        { n: "BB-2", name: "Wrecker" },
        { n: "BB-3", name: "Tech" },
        { n: "BB-4", name: "Crosshair" },
        { n: "BB-5", name: "Echo" },
        { n: "BB-6", name: "Omega" },
        { n: "BB-7", name: "Vice Admiral Rampart" },
        { n: "BB-8", name: "Admiral Tarkin" },
        { n: "BB-9", name: "Nala Se" },
        { n: "BB-10", name: "Lama Su" },
        { n: "BB-11", name: "Cid" },
        { n: "BB-12", name: "Cut Lawquane" },
        { n: "BB-13", name: "Gregor" },
        { n: "BB-14", name: "Cad Bane" },
        { n: "BB-15", name: "Fennec Shand" },
        { n: "BB-16", name: "Saw Gerrera" },
        { n: "BB-17", name: "Bolo" },
        { n: "BB-18", name: "Ketch" },
        { n: "BB-19", name: "Hera Syndulla" },
        { n: "BB-20", name: "Cham Syndulla" },
    ],
  },
  {
    id: "book-of-boba-fett",
    type: "insert",
    title: "THE BOOK OF BOBA FETT",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "BF-1", name: "Boba Fett" },
        { n: "BF-2", name: "Fennec Shand" },
    ],
  },
  {
    id: "galaxys-finest-heroes-die-cut",
    type: "insert",
    title: "GALAXY'S FINEST HEROES DIE-CUT",
    parallels: [
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "GF-1", name: "Luke Skywalker" },
        { n: "GF-2", name: "Han Solo" },
        { n: "GF-3", name: "Yoda" },
        { n: "GF-4", name: "Leia Organa" },
        { n: "GF-5", name: "The Mandalorian" },
        { n: "GF-6", name: "Chewbacca" },
        { n: "GF-7", name: "Rey" },
        { n: "GF-8", name: "Finn" },
        { n: "GF-9", name: "R2-D2" },
        { n: "GF-10", name: "Obi-Wan Kenobi" },
        { n: "GF-11", name: "Lando Calrissian" },
        { n: "GF-12", name: "Jyn Erso" },
        { n: "GF-13", name: "Poe Dameron" },
        { n: "GF-14", name: "Chirrut Îmwe" },
        { n: "GF-15", name: "Ahsoka Tano" },
        { n: "GF-16", name: "Saw Gerrera" },
        { n: "GF-17", name: "Qui-Gon Jinn" },
        { n: "GF-18", name: "Mace Windu" },
        { n: "GF-19", name: "Rose Tico" },
        { n: "GF-20", name: "Padmé Amidala" },
    ],
  },
  {
    id: "finest-autographs",
    type: "auto",
    title: "FINEST AUTOGRAPHS",
    parallels: [
        { id: "purple-refractor", name: "Purple Refractor", print_run: 299, color: "#b060ff" },
        { id: "aqua-refractor", name: "Aqua Refractor", print_run: 199, color: "#00e5ff" },
        { id: "blue-refractor", name: "Blue Refractor", print_run: 199, color: "#2979ff" },
        { id: "green-refractor", name: "Green Refractor", print_run: 99, color: "#00e676" },
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "FA-AB", name: "Ahmed Best" },
        { n: "FA-ABR", name: "Anna Brewster" },
        { n: "FA-AD", name: "Annabelle Davis" },
        { n: "FA-AE", name: "Alden Ehrenreich" },
        { n: "FA-AH", name: "Alan Harris" },
        { n: "FA-AP", name: "Angelique Perrin" },
        { n: "FA-APE", name: "Alistair Petrie" },
        { n: "FA-AS", name: "Andy Serkis" },
        { n: "FA-AT", name: "Alan Tudyk" },
        { n: "FA-BL", name: "Billie Lourd" },
        { n: "FA-BM", name: "Ben Mendelsohn" },
        { n: "FA-BV", name: "Brian Vernel" },
        { n: "FA-CA", name: "Cas Anvar" },
        { n: "FA-CB", name: "Caroline Blakiston" },
        { n: "FA-CC", name: "Crystal Clarke" },
        { n: "FA-CH", name: "Clint Howard" },
        { n: "FA-CM", name: "Cameron Monaghan" },
        { n: "FA-CP", name: "Chris Parsons" },
        { n: "FA-DB", name: "Dante Briggins" },
        { n: "FA-DBB", name: "Dee Bradley Baker" },
        { n: "FA-DG", name: "Domhnall Gleeson" },
        { n: "FA-DM", name: "Dominic Monaghan" },
        { n: "FA-DY", name: "Donnie Yen" },
        { n: "FA-EK", name: "Erin Kellyman" },
        { n: "FA-ES", name: "Emily Swallow" },
        { n: "FA-FW", name: "Forest Whitaker" },
        { n: "FA-GG", name: "Greg Grunberg" },
        { n: "FA-GT", name: "George Takei" },
        { n: "FA-IL", name: "Ian Whyte" },
        { n: "FA-IMC", name: "Ian McElhinney" },
        { n: "FA-JA", name: "Josef Altin" },
        { n: "FA-JB", name: "Jeremy Bulloch" },
        { n: "FA-JC", name: "Jim Cummings" },
        { n: "FA-JD", name: "Julie Dolan" },
        { n: "FA-JI", name: "Jason Isaacs" },
        { n: "FA-JS", name: "Jason Spisak" },
        { n: "FA-JT", name: "John Tui" },
        { n: "FA-KG", name: "Kathleen Gati" },
        { n: "FA-KK", name: "Katy Kartwheel" },
        { n: "FA-KMT", name: "Kelly Marie Tran" },
        { n: "FA-LC", name: "Lily Cole" },
        { n: "FA-MC", name: "Michaela Cottrell" },
        { n: "FA-MD", name: "Mark Dodson" },
        { n: "FA-MM", name: "Mads Mikkelsen" },
        { n: "FA-MS", name: "Meredith Salenger" },
        { n: "FA-MW", name: "Matthew Wood" },
        { n: "FA-NA", name: "Naomi Ackie" },
        { n: "FA-OFD", name: "Oliver Ford Davies" },
        { n: "FA-PA", name: "Philip Alexander" },
        { n: "FA-PB", name: "Paul Bettany" },
        { n: "FA-PK", name: "Paul Kasey" },
        { n: "FA-PL", name: "Phil Lamarr" },
        { n: "FA-PRU", name: "Paul Reubens" },
        { n: "FA-PW", name: "Paul Warren" },
        { n: "FA-RB", name: "Richard Brake" },
        { n: "FA-RG", name: "Rusty Goffe" },
        { n: "FA-RO", name: "Rena Owen" },
        { n: "FA-RP", name: "Ron Perlman" },
        { n: "FA-SL", name: "Scott Lawrence" },
        { n: "FA-SMG", name: "Sarah Michelle Gellar" },
        { n: "FA-SST", name: "Stephen Stanton" },
        { n: "FA-SW", name: "Sam Witwer" },
        { n: "FA-TB", name: "Tom Baker" },
        { n: "FA-TC", name: "Tim Curry" },
        { n: "FA-TE", name: "Tom Edden" },
        { n: "FA-TR", name: "Tim Rose" },
        { n: "FA-VK", name: "Valene Kane" },
        { n: "FA-VR", name: "Vinette Robinson" },
        { n: "FA-WD", name: "Warwick Davis" },
        { n: "FA-WH", name: "Werner Herzog" },
    ],
  },
  {
    id: "galaxys-finest-heroes-die-cut-autographs",
    type: "auto",
    title: "GALAXY'S FINEST HEROES DIE-CUT AUTOGRAPHS",
    parallels: [
      ],
    cards: [
        { n: "GF-AE", name: "Ashley Eckstein" },
        { n: "GF-AT", name: "Alan Tudyk" },
        { n: "GF-BDW", name: "Billy Dee Williams" },
        { n: "GF-BL", name: "Billie Lourd" },
        { n: "GF-DY", name: "Donnie Yen" },
        { n: "GF-FPJ", name: "Freddie Prinze Jr." },
        { n: "GF-HQ", name: "Hugh Quarshie" },
        { n: "GF-JAT", name: "James Arnold Taylor" },
        { n: "GF-JB", name: "John Boyega" },
        { n: "GF-JH", name: "Jessica Henwick" },
        { n: "GF-KMT", name: "Kelly Marie Tran" },
        { n: "GF-LD", name: "Laura Dern" },
        { n: "GF-NA", name: "Naomi Ackie" },
        { n: "GF-OD", name: "Olivia d'Abo" },
        { n: "GF-PL", name: "Phil Lamarr" },
        { n: "GF-PSL", name: "Paul Sun-Hyung Lee" },
        { n: "GF-RA", name: "Riz Ahmed" },
        { n: "GF-RAD", name: "Robin Atkin Downes" },
        { n: "GF-RD", name: "Rosario Dawson" },
        { n: "GF-TG", name: "Taylor Gray" },
    ],
  },
  {
    id: "the-mandalorian-autographs",
    type: "auto",
    title: "THE MANDALORIAN AUTOGRAPHS",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "MA-CW", name: "Carl Weathers" },
        { n: "MA-DLI", name: "Diana Lee Inosanto" },
        { n: "MA-GE", name: "Giancarlo Esposito" },
        { n: "MA-MV", name: "Mercedes Varnado" },
        { n: "MA-NN", name: "Nick Nolte" },
        { n: "MA-OA", name: "Omid Abtahi" },
        { n: "MA-SK", name: "Simon Kassianides" },
        { n: "MA-TM", name: "Temuera Morrison" },
        { n: "MA-TW", name: "Taika Waititi" },
        { n: "MA-WH", name: "Werner Herzog" },
    ],
  },
  {
    id: "book-of-boba-fett-autographs",
    type: "auto",
    title: "THE BOOK OF BOBA FETT AUTOGRAPHS",
    parallels: [
        { id: "gold-refractor", name: "Gold Refractor", print_run: 50, color: "#f0c040" },
        { id: "orange-refractor", name: "Orange Refractor", print_run: 25, color: "#ff9100" },
        { id: "black-refractor", name: "Black Refractor", print_run: 10, color: "#a8a8b4" },
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "BA-TM", name: "Temuera Morrison" },
    ],
  },
  {
    id: "prime-autographs",
    type: "auto",
    title: "PRIME AUTOGRAPHS",
    parallels: [
        { id: "red-refractor", name: "Red Refractor", print_run: 5, color: "#ff1744" },
        { id: "superfractor", name: "Superfractor", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "PA-AD", name: "Adam Driver" },
        { n: "PA-CF", name: "Carrie Fisher" },
        { n: "PA-DR", name: "Daisy Ridley" },
        { n: "PA-EM", name: "Ewan McGregor" },
        { n: "PA-FJ", name: "Felicity Jones" },
        { n: "PA-HC", name: "Hayden Christensen" },
        { n: "PA-HF", name: "Harrison Ford" },
        { n: "PA-NP", name: "Natalie Portman" },
        { n: "PA-SJ", name: "Samuel L. Jackson" },
    ],
  },
  {
    id: "sketch-cards",
    type: "sketch",
    title: "SKETCH CARDS",
    parallels: [
        { id: "one-of-one", name: "", print_run: 1, color: "#f0c040" },
      ],
    cards: [
        { n: "SK-1", name: "Cyrus Sherkat" },
        { n: "SK-2", name: "Benjamin Lombart" },
        { n: "SK-3", name: "Lindsey Greyling" },
        { n: "SK-4", name: "Keith Farnum" },
        { n: "SK-5", name: "Jim Mehsling" },
        { n: "SK-6", name: "Oscar Chavez" },
        { n: "SK-7", name: "John Bruce" },
        { n: "SK-8", name: "Logan Monette" },
        { n: "SK-9", name: "Michael Munshaw" },
        { n: "SK-10", name: "Rich Hennemann" },
        { n: "SK-11", name: "Tom Amici" },
        { n: "SK-12", name: "Tim Shinn" },
        { n: "SK-13", name: "Ryan Finley" },
        { n: "SK-14", name: "Veronica Louro" },
        { n: "SK-15", name: "Darrin Pepe" },
        { n: "SK-16", name: "Marlo Agunos" },
        { n: "SK-17", name: "Allen Grimes" },
        { n: "SK-18", name: "Andrew Perkins" },
        { n: "SK-19", name: "Angel Aviles" },
        { n: "SK-20", name: "Brandon Blevins" },
        { n: "SK-21", name: "Brad Hudson" },
        { n: "SK-22", name: "Chris Colyer" },
        { n: "SK-23", name: "Dan Lawler" },
        { n: "SK-24", name: "Daniel Riveron" },
        { n: "SK-25", name: "Dwayne Carpenter" },
        { n: "SK-26", name: "Dawn Murphy" },
        { n: "SK-27", name: "Francisco Rivera" },
        { n: "SK-28", name: "Eric Lehtonen" },
        { n: "SK-29", name: "Jason Davies" },
        { n: "SK-30", name: "Frank Sansone" },
        { n: "SK-31", name: "Jamison Murdock" },
        { n: "SK-32", name: "Jason Montoya" },
        { n: "SK-33", name: "Jason Sobol" },
        { n: "SK-34", name: "Jay James Manchand" },
        { n: "SK-35", name: "Jenna McGrath" },
        { n: "SK-36", name: "John Pleak" },
        { n: "SK-37", name: "Jonathan Beistline" },
        { n: "SK-38", name: "Kevin Cleaveland" },
        { n: "SK-39", name: "Kevin P. West" },
        { n: "SK-40", name: "Marcia Dye" },
        { n: "SK-41", name: "Matt Stewart" },
        { n: "SK-42", name: "Patricio Carrasco" },
        { n: "SK-43", name: "Quinton Baker" },
        { n: "SK-44", name: "Rees Finlay" },
        { n: "SK-45", name: "RJ Tomascik" },
        { n: "SK-46", name: "Rob Teranishi" },
        { n: "SK-47", name: "Robert Stewart" },
        { n: "SK-48", name: "Rugved Bhuskute" },
        { n: "SK-49", name: "Semra Bulut" },
        { n: "SK-50", name: "CJ Jones" },
        { n: "SK-51", name: "Shyla Lee" },
        { n: "SK-52", name: "Ward Silverman" },
        { n: "SK-53", name: "Veronica Smith" },
        { n: "SK-54", name: "Andrew Fry" },
        { n: "SK-55", name: "Camron Johnson" },
        { n: "SK-56", name: "Zach Woolsey" },
        { n: "SK-57", name: "Rich Molinelli" },
        { n: "SK-58", name: "Brent Scotchmer" },
        { n: "SK-59", name: "Basak Kahraman" },
        { n: "SK-60", name: "Jessica Hickman" },
        { n: "SK-61", name: "Jamie Cosley" },
        { n: "SK-62", name: "Todd Purnell" },
        { n: "SK-63", name: "Yves Van Berlo" },
    ],
  },
];

export const ALL_CARD_KEYS = SETS.flatMap(set =>
  set.cards.map(card => `${set.id}__${card.n}`)
);

// Fallback exports used by Checklist.js for any sub-set with no inline `parallels`.
// Every sub-set above has its own inline array, so these stay empty.
export const PARALLELS = [];
export const AUTO_PARALLELS = [];
export const INSERT_PARALLELS = [];
